let Images = {
  // =============================CommonImgs===================================
  LOGO_IMG: process.env.PUBLIC_URL + "/healink-logo-light.svg",
  USER_DUMMY_IMG: require("../../Assets/Images/Common/dummyImg.png"),
  // USER_DUMMY_IMG1: require("../../Assets/Images/Common/dummyImg.png"),

  // =============================landingPageImgs===================================
  // LANDING_IMG: require("../../Assets/Images/Landing/LandingPageImg.png"),

  // ============================TeethSculptureImgs=================================
  TEETH_ONE_IMG: require("../../Assets/Images/TeethSculpture/Frame 3565.png"),
  TEETH_TWO_IMG: require("../../Assets/Images/TeethSculpture/Frame 3566.png"),
  TEETH_THREE_IMG: require("../../Assets/Images/TeethSculpture/Frame 3567.png"),
  TEETH_FOUR_IMG: require("../../Assets/Images/TeethSculpture/Frame 3568.png"),
  TEETH_FIVE_IMG: require("../../Assets/Images/TeethSculpture/Frame 3569.png"),
  TEETH_SIX_IMG: require("../../Assets/Images/TeethSculpture/Frame 3570.png"),
  TEETH_SEVEN_IMG: require("../../Assets/Images/TeethSculpture/Frame 3571.png"),
  TEETH_EIGHT_IMG: require("../../Assets/Images/TeethSculpture/Frame 3572.png"),
  TEETH_NINE_IMG: require("../../Assets/Images/TeethSculpture/Frame 3573.png"),
  TEETH_TEN_IMG: require("../../Assets/Images/TeethSculpture/Frame 3574.png"),
  TEETH_ELEVEN_IMG: require("../../Assets/Images/TeethSculpture/Frame 3575.png"),
  TEETH_TWELVE_IMG: require("../../Assets/Images/TeethSculpture/Frame 3576.png"),
  TEETH_THIRTEEN_IMG: require("../../Assets/Images/TeethSculpture/Frame 3577.png"),
  TEETH_FOURTEEN_IMG: require("../../Assets/Images/TeethSculpture/Frame 3578.png"),
  TEETH_FIFTEEN_IMG: require("../../Assets/Images/TeethSculpture/Frame 3579.png"),
  TEETH_SIXTEEN_IMG: require("../../Assets/Images/TeethSculpture/Frame 3580.png"),
  TEETH_SEVENTEEN_IMG: require("../../Assets/Images/TeethSculpture/Frame 3549.png"),
  TEETH_EIGHTEEN_IMG: require("../../Assets/Images/TeethSculpture/Frame 3550.png"),
  TEETH_NINETEEN_IMG: require("../../Assets/Images/TeethSculpture/Frame 3551.png"),
  TEETH_TWENTY_IMG: require("../../Assets/Images/TeethSculpture/Frame 3552.png"),
  TEETH_TWENTY_ONE_IMG: require("../../Assets/Images/TeethSculpture/Frame 3553.png"),
  TEETH_TWENTY_TWO_IMG: require("../../Assets/Images/TeethSculpture/Frame 3554.png"),
  TEETH_TWENTY_THREE_IMG: require("../../Assets/Images/TeethSculpture/Frame 3555.png"),
  TEETH_TWENTY_FOUR_IMG: require("../../Assets/Images/TeethSculpture/Frame 3556.png"),
  TEETH_TWENTY_FIVE_IMG: require("../../Assets/Images/TeethSculpture/Frame 3557.png"),
  TEETH_TWENTY_SIX_IMG: require("../../Assets/Images/TeethSculpture/Frame 3558.png"),
  TEETH_TWENTY_SEVEN_IMG: require("../../Assets/Images/TeethSculpture/Frame 3559.png"),
  TEETH_TWENTY_EIGHT_IMG: require("../../Assets/Images/TeethSculpture/Frame 3560.png"),
  TEETH_TWENTY_NINE_IMG: require("../../Assets/Images/TeethSculpture/Frame 3561.png"),
  TEETH_THIRTY_IMG: require("../../Assets/Images/TeethSculpture/Frame 3562.png"),
  TEETH_THIRTY_ONE_IMG: require("../../Assets/Images/TeethSculpture/Frame 3563.png"),
  TEETH_THIRTY_TWO_IMG: require("../../Assets/Images/TeethSculpture/Frame 3564.png"),
};

export default Images;
